export default __webpack_public_path__ + "static/media/Group 15530.f4b0dc78.svg";